import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBriefNotification } from "@shared/lib/types/brief";
import { BRIEF_NOTIFICATIONS_QUERY_KEY } from "../../constants";
import { BriefService } from "../../services/brief.service";

export default function useResolveNotification(briefId: string) {
  const {
    mutate: resolveNotification,
    isLoading: isResolving,
    isSuccess: isResolved,
    variables,
  } = useMutation({
    mutationFn: (notificationId: string) =>
      BriefService.resolveBriefNotification(briefId, notificationId).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {
      skipInvalidation: true,
    },
    onSuccess: (c, data, notificationId) => {
      // c.invalidateQueries({ queryKey: BRIEF_NOTIFICATIONS_QUERY_KEY(briefId) });
      c.setQueryData(
        BRIEF_NOTIFICATIONS_QUERY_KEY(briefId),
        (oldData: BackednResponse<{ data: IBriefNotification[] }>) => {
          return {
            ...oldData,
            data: {
              ...oldData.data,
              data: oldData.data.data.map((notification) => {
                if (notification._id === notificationId) {
                  return data.data;
                }
                return notification;
              }),
            },
          };
        }
      );
    },
  });
  return {
    resolveNotification,
    isResolving,
    isResolved,
    notificationToResolve: variables,
  };
}
